"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStorageVarName = void 0;
var SessionStorageVarName;
(function (SessionStorageVarName) {
    SessionStorageVarName["BrowserSessionUid"] = "_$w_browserSessionUid";
})(SessionStorageVarName = exports.SessionStorageVarName || (exports.SessionStorageVarName = {}));
//# sourceMappingURL=session-storage-var-names.js.map